import { AlertBox } from 'shared/ui/AlertBox';

import { IncreaseBudgetBtn } from '../IncreaseBudgerCampaign';

import type { AlertTextType } from './interfaces';

interface OverbudgetAlertProps {
  alertText: AlertTextType;
  showIncreaseBudgetBtnBtn?: boolean;
}

export function OverbudgetAlert({ showIncreaseBudgetBtnBtn = false, alertText }: Readonly<OverbudgetAlertProps>) {
  const { header, subText } = alertText;

  return (
    <AlertBox
      className="items-center border-magenta-100"
      iconClass="text-magenta-500 self-start"
      iconName="info"
    >
      <div className="text-sm">
        <div className="font-medium">{header}</div>
        {subText && <div className="mt-2 text-slate-700">{subText}</div>}
        {showIncreaseBudgetBtnBtn && (
          <div>
            <IncreaseBudgetBtn />
          </div>
        )}
      </div>
    </AlertBox>
  );
}
